const userCenterRoute = [
  // 作品管理
  {
    path: "/works",
    name: "Works",
    component: () => import("@/views/userCenter/works/index.vue"),
    redirect: "/works/workmanagement",
    meta: {
      activeName: "Works",
    },
    children: [
      {
        path: "workmanagement",
        name: "WorkManagement",
        component: () => import("@/views/userCenter/works/workManagement.vue"),
        meta: {
          activeName: "Works",
        },
      },
      {
        path: "workupload",
        name: "WorkUpload",
        component: () => import("@/views/userCenter/works/workUpload.vue"),
        meta: {
          activeName: "Works",
        },
      },
      {
        path: "workdetail",
        name: "WorkDetail",
        component: () => import("@/views/userCenter/works/workDetail.vue"),
        meta: {
          activeName: "Works",
        },
      },
    ],
  },

  // 客户管理
  {
    path: "/customer",
    name: "Customer",
    component: () => import("@/views/userCenter/customer/index.vue"),
    redirect: "/customer/customermanage",
    meta: {
      activeName: "Customer",
    },
    children: [
      {
        path: "customermanage",
        name: "CustomerManage",
        component: () =>
          import("@/views/userCenter/customer/customerManage.vue"),
        meta: {
          activeName: "Customer",
        },
      },
      {
        path: "groupdetail",
        name: "GroupDetail",
        component: () => import("@/views/userCenter/customer/groupDetail.vue"),
        meta: {
          activeName: "Customer",
        },
      },
      {
        path: "customerdetail",
        name: "CustomerDetail",
        component: () =>
          import("@/views/userCenter/customer/customerDetail.vue"),
        meta: {
          activeName: "Customer",
        },
      },
      {
        path: "customeredit",
        name: "CustomerEdit",
        component: () =>
          import("@/views/userCenter/customer/customerEdit.vue"),
        meta: {
          activeName: "Customer",
        },
      },
    ],
  },

  // 项目管理
  {
    path: "/project",
    name: "Project",
    component: () => import("@/views/userCenter/project/index.vue"),
    redirect: "/project/projectmanage",
    children: [
      {
        path: "projectmanage",
        name: "ProjectManage",
        component: () => import("@/views/userCenter/project/projectManage.vue"),
        meta: {
          activeName: "Project",
        },
      },
      {
        path: "projectdetail",
        name: "ProjectDetail",
        component: () => import("@/views/userCenter/project/projectDetail.vue"),
        meta: {
          activeName: "Project",
        },
      },
    ],
  },
  // 合同管理
  {
    path: "/contract",
    name: "Contract",
    component: () => import("@/views/userCenter/contractManage/index.vue"),
    redirect: "/contract/contractManage",
    children: [
      {
        path: "contractManage",
        name: "ContractManage",
        component: () => import("@/views/userCenter/contractManage/contractManage.vue"),
        meta: {
          activeName: "Contract",
        },
      },
      {
        path: "contractDetail",
        name: "ContractDetail",
        component: () => import("@/views/userCenter/contractManage/contractDetail.vue"),
        meta: {
          activeName: "Contract",
        },
      },
    ],
  },
  // 发票管理
  {
    path: "/invoice",
    name: "Invoice",
    component: () => import("@/views/userCenter/invoiceManage/index.vue"),
    redirect: "/invoice/invoicemanage",
    children: [
      {
        path: "invoicemanage",
        name: "InvoiceManage",
        component: () => import("@/views/userCenter/invoiceManage/invoiceManage.vue"),
        meta: {
          activeName: "Invoice",
        },
      },
      // {
      //   path: "contractDetail",
      //   name: "ContractDetail",
      //   component: () => import("@/views/userCenter/contractManage/contractDetail.vue"),
      //   meta: {
      //     activeName: "Contract",
      //   },
      // },
    ],
  },
  // 推广管理
  {
    path: "/promotion",
    name: "Promotion",
    component: () => import("@/views/userCenter/promotionManage/index.vue"),
    meta: {
      activeName: "Promotion",
    }
  },
  // 客户分组
  {
    path: "/customerGroup",
    name: "CustomerGroup",
    component: () => import("@/views/userCenter/customerGroup/index.vue"),
    meta: {
      activeName: "CustomerGroup",
    }
  },
  // 空间管理
  {
    path: "/spacemanage",
    name: "SpaceManage",
    component: () => import("@/views/userCenter/spaceManage/spaceManage.vue"),
    meta: {
      activeName: "SpaceManage",
    }
  },
];

export default userCenterRoute;
